export default defineNuxtRouteMiddleware((to, from) => {
  const { user, loading } = useAuth()
  
  // Skip middleware during SSR
  if (import.meta.server) return
  
  // Wait for auth to finish loading
  if (loading.value) {
    return
  }
  
  // If not authenticated, redirect to signin
  if (!user.value) {
    return navigateTo('/auth/signin')
  }
})
